import type { CityConfig } from "../city-template/types";

export const caryConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Cary",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "cary",
  route: "/cary",
  title: "Emergency Passport Cary, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cary, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wake County and the Research Triangle. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Cary, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Cary and Research Triangle area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20suburban%20view%20of%20Cary%20North%20Carolina%20with%20lush%20green%20parks%20and%20tree-lined%20neighborhoods%2C%20modern%20residential%20areas%20mixed%20with%20greenways%20and%20walking%20trails%2C%20the%20historic%20downtown%20Cary%20district%20with%20charming%20shops%2C%20warm%20golden%20afternoon%20sunlight%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20well-manicured%20lawns%20and%20American%20suburban%20charm%2C%20professional%20landscape%20photography%20with%20vibrant%20green%20colors%20and%20natural%20warm%20lighting%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=cary-hero-nc-001&orientation=landscape",
  heroImageAlt: "Cary North Carolina suburban landscape with green parks and tree-lined neighborhoods",
  geoPosition: "35.7915;-78.7811",
  geoPlacename: "Cary, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 280 miles north of Cary — about 4.5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Cary", zips: "27511, 27512, 27513, 27518, 27519" },
    { name: "Apex", zips: "27502, 27523, 27539" },
    { name: "Morrisville", zips: "27560" },
    { name: "Holly Springs", zips: "27540" },
    { name: "Fuquay-Varina", zips: "27526" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27515, 27516, 27517" },
    { name: "Garner", zips: "27529" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Knightdale", zips: "27545" },
    { name: "Clayton", zips: "27520, 27527, 27528" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cary departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Research Triangle Coverage", desc: "Serving Cary, Apex, Morrisville, and the entire Triangle" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Durham, NC", route: "/durham" },
    { name: "Emergency passport help in Apex, NC", route: "/apex" },
    { name: "Urgent passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Same-day passport help in Chapel Hill, NC", route: "/chapel-hill" },
    { name: "Passport courier services in Concord, NC", route: "/concord-nc" },
    { name: "Fast passport renewal in Wake Forest, NC", route: "/wake-forest" },
    { name: "Passport courier services in Holly Springs, NC", route: "/holly-springs" },
    { name: "Passport courier services in Fuquay-Varina, NC", route: "/fuquay-varina" },
    { name: "Emergency passport help in Morrisville, NC", route: "/morrisville" },
    { name: "Passport courier services in Garner, NC", route: "/garner" },
    { name: "Emergency passport help in Clayton, NC", route: "/clayton" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cary remotely via secure courier. We do not have a walk-in office in Cary — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wake County and the Research Triangle area travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Wake County and the Research Triangle including Durham and Orange counties",
  serviceAreaIntro: "From downtown Cary to the neighborhoods of Apex and Morrisville, from Holly Springs to Fuquay-Varina and Garner — Fast Passport Center serves the entire Research Triangle region. We regularly help travelers from Raleigh, Durham, and Chapel Hill get their passports fast.",
  nearbyCitiesIntro: "We serve all Cary neighborhoods and the surrounding Research Triangle area including Apex, Morrisville, Holly Springs, Fuquay-Varina, Raleigh, Durham, Chapel Hill, Garner, Wake Forest, Knightdale, and Clayton. If you are anywhere in Wake, Durham, or Orange counties, we have you covered.",
  howItWorksIntro: "Most Cary travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Cary travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Cary and Research Triangle travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cary? Here are the most common ones we hear from Wake County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Cary international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rebecca L.",
      location: "Cary, NC",
      rating: 5,
      text: "My passport expired the week before our anniversary trip to Paris. Fast Passport Center had my renewal in 4 days. Never had to leave Cary. The service was absolutely flawless.",
      service: "Passport Renewal",
    },
    {
      name: "Michael S.",
      location: "Apex, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in London. Got it in 30 hours. The team was incredibly responsive and professional. I could not have made that flight without them.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer K.",
      location: "Morrisville, NC",
      rating: 5,
      text: "Business trip to Singapore came up with 6 days notice. They got me a passport in 3 business days. The dedicated agent made the whole process effortless from start to finish.",
      service: "Emergency Passport",
    },
    {
      name: "David P.",
      location: "Holly Springs, NC",
      rating: 5,
      text: "First passport for my daughter before her study abroad in Rome. Fast Passport Center guided us through every step. Ready in 5 days with zero stress. Highly recommend to any Triangle family.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "cary-1",
      name: "Cary Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1813 N Harrison Ave",
      city: "Cary",
      state: "NC",
      zip: "27513",
      phone: "(919) 467-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Cary",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cary facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "cary-2",
      name: "Apex Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "640 E Williams St",
      city: "Apex",
      state: "NC",
      zip: "27502",
      phone: "(919) 362-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southwest Cary suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Apex and Holly Springs residents. Less crowded than downtown Cary. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "cary-3",
      name: "Morrisville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3601 Davis Dr",
      city: "Morrisville",
      state: "NC",
      zip: "27560",
      phone: "(919) 467-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Cary, RDU Airport area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Morrisville and RDU Airport area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "cary-4",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Fayetteville St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 896-5310",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Cary, downtown Raleigh",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Raleigh and east Wake County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cary-5",
      name: "Wake County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "316 Fayetteville St",
      city: "Raleigh",
      state: "NC",
      zip: "27601",
      phone: "(919) 792-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Wake County Courthouse, downtown Raleigh",
      website: "https://www.wakegov.com/",
      websiteLabel: "Wake County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cary-6",
      name: "Durham Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "323 E Chapel Hill St",
      city: "Durham",
      state: "NC",
      zip: "27701",
      phone: "(919) 683-6842",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Cary, Durham County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Durham County and west Wake County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cary photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wake County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cary applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wake County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cary travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cary." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cary address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Cary before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cary for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Cary?", a: "Fast Passport Center offers fast passport renewal in Cary in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Cary?", a: "The nearest regional passport agency to Cary is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 280 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cary without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Cary?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4.5 hours from Cary — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Wake County residents." },
    { q: "Do you serve the entire Research Triangle?", a: "Absolutely. Fast Passport Center serves the entire Research Triangle including Cary, Raleigh, Durham, Chapel Hill, Apex, Morrisville, Holly Springs, Fuquay-Varina, Garner, Wake Forest, Knightdale, and Clayton. Our courier service works seamlessly from any address in Wake, Durham, or Orange counties." },
    { q: "Can I expedite a child passport in Cary?", a: "Yes. Fast Passport Center expedites child passports in Cary for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wake County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Cary with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Cary", address: "1010 E Williams St, Cary, NC 27511", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Cary", address: "2305 SW Cary Pkwy, Cary, NC 27513", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart Supercenter — Cary", address: "1101 N Harrison Ave, Cary, NC 27513", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "FedEx Office — Cary", address: "2900 E Millbrook Rd, Raleigh, NC 27604", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/en-us/nc/raleigh" },
    { name: "CVS Pharmacy — Apex", address: "1011 E Williams St, Apex, NC 27502", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Morrisville", address: "1000 Market Center Dr, Morrisville, NC 27560", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Raleigh", address: "201 S Wilmington St, Raleigh, NC 27601", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Durham", address: "1010 Martin Luther King Jr Pkwy, Durham, NC 27713", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Cary",
      address: "2991 E Chatham St, Cary, NC 27518",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Raleigh Central",
      address: "1100 New Bern Ave, Raleigh, NC 27601",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Durham",
      address: "3820 S Roxboro St, Durham, NC 27713",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Durham and Chapel Hill residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Apex",
      address: "640 E Williams St, Apex, NC 27502",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves south Wake County and Apex residents. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "8 miles east of downtown Cary",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub serving the Research Triangle. Direct flights to London, Paris, Cancun, and major domestic destinations. The closest and most convenient airport for Cary travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "65 miles west of Cary",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Alternative airport for west Wake County residents. Additional domestic routes.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "150 miles southwest of Cary",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for additional international options.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Wake County Register of Deeds',
      description: 'Marriage licenses and records for Wake County. Apply in person or request certified copies.',
      url: 'https://www.wake.gov/departments-government/register-deeds',
    },
    {
      label: 'Wake County Clerk of Superior Court',
      description: 'Divorce records and decrees for Wake County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/wake-county/wake-county-clerk-of-superior-court',
    },
  ],
};